import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "./App.css"; // Ensure your CSS file is correctly linked
import axios from "axios";
import Body from "./components/Body/Body";
import jsonData from "./components/Jsons/ai-branding.json";
import Spinner from "react-bootstrap/Spinner";
import Helmet from "react-helmet";


// Lazy load non-critical components
const ForbsCarousel = lazy(() => import("./components/ForbsCarousel/index"));
const Footer = lazy(() => import("./components/Footer/index"));
const Highlights = lazy(() => import("./components/Highlights/Highlights"));
const LogoSection = lazy(() => import("./components/Logo Section/Logo"));
const VideoSection = lazy(() => import("./components/VideoSection/ExploreSection"));
const NewsHighlights = lazy(() => import("./components/Carousel/carousel"));
const ReelSection = lazy(() => import("./components/ReelSection/reel"));
const FlowChart = lazy(() => import("./components/Flowchart/FlowChart"));
const SignUpForm = lazy(() => import("./components/SignUpForm/SignUpForm"));

function App() {
  const [webinarData, setWebinarData] = useState();
  const [bannerData, setBannerData] = useState();
  const [highlightsData, setHighlightsData] = useState();
  const [timerData, setTimerData] = useState();
  const [formData, setFormData] = useState();
  const [links, setLinks] = useState(null);
  const [WorkflowId, setWorkflowId] = useState();
  const [WorkflowKey, setWorkflowKey] = useState();
  const [showOtherComponents, setShowOtherComponents] = useState(false);

 // Scroll-triggered component loading
 useEffect(() => {
  const handleScroll = () => {
    // Trigger scroll logic only for screen sizes below 992px
    if (window.innerWidth < 992) {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    }
  };

  // Default state for larger screens
  if (window.innerWidth >= 992) {
    setShowOtherComponents(true);
  }

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  // Fetch external JSON data for links
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        setLinks(jsonData); // Use local fallback data
      }
    };

    if (!links) {
      fetchLinks();
    }
  }, [links]);

  // Fetch webinar-related data
  useEffect(() => {
    const fetchMorganWebinarJSON = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_LIONJSON_CDN_URL);
        const webinarJsonData = response.data;
        setWebinarData(webinarJsonData);
        setBannerData(webinarJsonData.banner);
        setHighlightsData(webinarJsonData.highlights);
        setTimerData(webinarJsonData.countdown);
        setFormData(webinarJsonData.signupform);
      } catch (error) {
        console.log(error);
      }
    };
    fetchMorganWebinarJSON();
  }, []);

  // Fetch workflow key data
  useEffect(() => {
    const fetchWorkflowKey = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_CDN_WORKFLOW_KEY);
        const fetchedWorkflowId = response.data.Workshop;
        setWorkflowId(fetchedWorkflowId);
        const workflowKey = await axios.post(process.env.REACT_APP_CDN_WORKFLOW_API, {
          workflow: fetchedWorkflowId,
        });
        setWorkflowKey(workflowKey.data.key);
      } catch (error) {
        console.error("Error fetching workflow key:", error);
      }
    };
    fetchWorkflowKey();
  }, []);

  // Show a spinner until critical data is loaded
  if (!bannerData || !links || !WorkflowKey) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <Spinner animation="border" role="status" style={{
          width: '3rem',  // Optional: Size customization
          height: '3rem', // Optional: Size customization
          borderWidth: '0.3em' // Optional: Border width
        }} />
      </div>
    );
  }

  return (
    <>
    <Helmet>
        <link rel="canonical" href="https://www.angelai.com/workshop/" />
      </Helmet>
    
    <div className="bodyContainer">
      <Body links={links} fetchpriority="high" />
     
      <Suspense fallback={
        <div style={{
          display: 'flex',
          justifyContent: 'center',
         
        }}>
          <Spinner animation="border" role="status" style={{
            width: '3rem',  // Optional: Size customization
            height: '3rem', // Optional: Size customization
            borderWidth: '0.3em' // Optional: Border width
          }} />
        </div>
      }>
       
        {showOtherComponents && (
          <>
            <ReelSection fetchpriority="low"/>
            <FlowChart links={links.current} WorkflowKey={WorkflowKey} fetchpriority="low" />
            <ForbsCarousel fetchpriority="low" />
            <Highlights highlightsData={highlightsData} links={links.current} WorkflowKey={WorkflowKey} />
            <LogoSection fetchpriority="low" />
            <NewsHighlights fetchpriority="low" />
            <SignUpForm fetchpriority="low" />
            <VideoSection links={links.current} fetchpriority="low" />
            <Footer links={links.current} fetchpriority="low" />
          </>
        )}
      </Suspense>
    </div>
    </>
  );
}

export default App;
